export default __webpack_public_path__ + "static/media/instagram.04850053.svg";